<div class="main-content">
  <div class="container-fluid">
      <div class="col-md-12">
          <div class="card">
              <div class="card-header card-header-danger">
                  <h4 class="card-title">ADD NEW Item Type </h4>
                  <p class="card-category">ALL Item TypeS </p>
              </div>
              <div class="card-body">
                  <form [formGroup]="AddItemTypeForm">
                      <div class="row">
                          <div class="col-md-12">
                              <mat-form-field class="example-full-width">
                                <input matInput placeholder="ItemType Name" 
                                formControlName="Name"   >
                              </mat-form-field>
                          </div>
                        
                        <div class="col-md-12">
                            <mat-form-field class="example-full-width">
                              <input matInput type="number" placeholder="Temp Normal Value" 
                              formControlName="TempValue"   >
                            </mat-form-field>
                        </div>
                        <div class="col-md-12 ">
                          <div class="form-group">
                            <label>Temp Opreator</label>
                            <ng-select class="form-control" [items]="Operator" bindLabel="name" bindValue="name" formControlName="TempOperator">
                            </ng-select>
                            <mat-error class="mt-2" *ngIf="fc.TempOperator.invalid && (fc.TempOperator.dirty || fc.TempOperator.touched)">
                              Temp Operator is required
                            </mat-error>
                          </div>
                        </div>
                        <div class="col-md-12">
                    
                          <mat-form-field class="example-full-width">
                            <textarea matInput placeholder="Hint Message Temp" 
                            formControlName="HintMessageTemp" ></textarea>
                          </mat-form-field>
                      </div>


                        <div class="col-md-3">
                            <mat-form-field class="example-full-width">
                              <input matInput placeholder="1 marker" 
                              formControlName="firstmarkertemp">
                            </mat-form-field>

                        </div>
                              <div class="col-md-3">
                            <mat-form-field class="example-full-width">
                              <input matInput placeholder="2 marker" 
                              formControlName="secondmarkertemp">
                            </mat-form-field>

                        </div>
                        <div class="col-md-3">
                          <mat-form-field class="example-full-width">
                            <input matInput placeholder="3 marker" 
                            formControlName="thirdmarkertemp">
                          </mat-form-field>

                      </div>
                      <div class="col-md-3">
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="4 marker" 
                          formControlName="fourthmarkertemp">
                        </mat-form-field>

                    </div>
               

                    <div class="col-md-3">
                      <mat-form-field class="example-full-width">
                        <input matInput placeholder="1 hold green" 
                        formControlName="firstholdtemp">
                      </mat-form-field>

                  </div>
                        <div class="col-md-3">
                      <mat-form-field class="example-full-width">
                        <input matInput placeholder="2 hold orange" 
                        formControlName="secondholdtemp">
                      </mat-form-field>

                  </div>
                  <div class="col-md-3">
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="3 hold red" 
                      formControlName="thirdholdtemp">
                    </mat-form-field>

                </div>

                      

                        <div class="col-md-12">
                          <mat-form-field class="example-full-width">
                            <input matInput type="number" placeholder=" Humitity Normal Value" 
                            formControlName="HumValue"   >
                          </mat-form-field>
                      </div>
                    
                          <div class="col-md-12 ">
                            <div class="form-group">
                              <label>Humitity Opreator</label>
                              <ng-select class="form-control" [items]="Operator" bindLabel="name" bindValue="name" formControlName="HumOperator">
                              </ng-select>
                              <mat-error class="mt-2" *ngIf="fc.HumOperator.invalid && (fc.HumOperator.dirty || fc.HumOperator.touched)">
                                Humitity Operator is required
                              </mat-error>
                            </div>
                          </div>
                              <div class="col-md-12">
                    
                          <mat-form-field class="example-full-width">
                            <textarea matInput placeholder="Hint Message Hum" 
                            formControlName="HintMessageHum"   ></textarea>
                          </mat-form-field>
                      </div>
                      <div class="col-md-3">
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="1 marker" 
                          formControlName="firstmarkerhum">
                        </mat-form-field>

                    </div>
                          <div class="col-md-3">
                        <mat-form-field class="example-full-width">
                          <input matInput placeholder="2 marker" 
                          formControlName="secondmarkerhum">
                        </mat-form-field>

                    </div>
                    <div class="col-md-3">
                      <mat-form-field class="example-full-width">
                        <input matInput placeholder="3 marker" 
                        formControlName="thirdmarkerhum">
                      </mat-form-field>

                  </div>
                  <div class="col-md-3">
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="4 marker" 
                      formControlName="fourthmarkerhum">
                    </mat-form-field>

                </div>
           

                <div class="col-md-3">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="1 hold green" 
                    formControlName="firstholdhum">
                  </mat-form-field>

              </div>
                    <div class="col-md-3">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="2 hold orange" 
                    formControlName="secondholdhum">
                  </mat-form-field>

              </div>
              <div class="col-md-3">
                <mat-form-field class="example-full-width">
                  <input matInput placeholder="3 hold red" 
                  formControlName="thirdholdhum">
                </mat-form-field>

            </div>


                      </div>

                      <button *ngIf="!update" mat-raised-button type="submit" class="btn primary pull-right"
                      [disabled]="AddItemTypeForm.invalid" (click)="Submit()">Add Item Type</button>
                      
                      <button  *ngIf="update" mat-raised-button type="submit" class="btn primary pull-right"
                      [disabled]="AddItemTypeForm.invalid" (click)="Submit()">Update Item Type</button>
                  </form>
              

                  <table mat-table [dataSource]="ItemTypes" class="mat-elevation-z8">

                      <!-- Position Column -->
                      <ng-container matColumnDef="ID">
                          <th mat-header-cell *matHeaderCellDef> ID </th>
                          <td mat-cell *matCellDef="let element"> {{element.id}}
                          </td>
                      </ng-container>

                      <!-- Name Column -->
                      <ng-container matColumnDef="Name">
                          <th mat-header-cell *matHeaderCellDef>Name</th>
                          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                      </ng-container>
                
                      <ng-container matColumnDef="TempValue">
                        <th mat-header-cell *matHeaderCellDef>Temp Value</th>
                        <td mat-cell *matCellDef="let element"> {{element.tempValue}} </td>
                    </ng-container>

                      <ng-container matColumnDef="TempOperator">
                        <th mat-header-cell *matHeaderCellDef>Temp Operator</th>
                        <td mat-cell *matCellDef="let element"> {{element.tempOperator}} </td>
                    </ng-container>

                          <ng-container matColumnDef="HumValue">
                        <th mat-header-cell *matHeaderCellDef>Hum Value</th>
                        <td mat-cell *matCellDef="let element"> {{element.humValue}} </td>
                    </ng-container>

                      <ng-container matColumnDef="HumOperator">
                        <th mat-header-cell *matHeaderCellDef>Hum Operator</th>
                        <td mat-cell *matCellDef="let element"> {{element.humOperator}} </td>
                    </ng-container>


                      <ng-container matColumnDef="action">
                          <th mat-header-cell *matHeaderCellDef> Action </th>
                          <td mat-cell *matCellDef="let element">
                            
                            <button mat-raised-button (click)="Edit(element)"><i class="material-icons">
                              edit
                          </i></button>
                         

                          </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
              </div>
          </div>
      </div>
  </div>
</div>